<script>
export default {
    name: 'ShutdownInfoBanner',
    methods: {
        close() {
            this.$emit('close');
        }
    },
};
</script>
<template>
    <div class="wrapper is-flex is-flex-direction-column is-align-items-center">
        <div class="container">
            <div class="text-container">
                <p>
                    <strong>Wichtige Information: Ein starkes Angebot wächst zusammen!</strong>
                </p>
                <br />

                <p>
                    Liebe Kundinnen und Kunden,<br />

                    hiermit wollen wir Ihnen gerne mitteilen, dass wir ab dem <strong style="text-decoration: underline;">16. März 2025</strong> unsere Kräfte für ein noch leistungsfähigeres Angebot bündeln und unseren Service über Meltwerk mit der Murtfeldt-Plattform ab diesem Zeitpunkt zusammenlegen: Sie können Ihre 3D-gedruckten Teile ab sofort noch einfacher und schneller über unsere Website <a href="https://murtfeldt-as.de">www.murtfeldt-as.de</a> hochladen, konfigurieren und bestellen.
                </p>
                <br />

                <p>
                    Alles in gewohnter Murtfeldt-Qualität – von der benutzerfreundlichen Registrierung und Bedienung über die große Materialvielfalt bis hin zur hochwertigen Fertigung.
                </p>

                <p>
                    Wir danken Ihnen für Ihr Vertrauen und freuen uns auf die weiterhin erfolgreiche Zusammenarbeit!
                </p>
                <br />
                <p>Ihr Murtfeldt-Team</p>
                <br />

                <div style="display: flex; justify-content: start;">
                    <b-button class="mb-3 mr-2">
                        <a href="https://murtfeldt-as.de">Zum Murtfeldt-AS Bestellportal</a>
                    </b-button>
                    <b-button class="mb-3" @click="close">
                        Zurück
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="css" scoped>
.wrapper {
    width: 100%;
}

.container {
    padding-top: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 800px !important;
    background-color: #FFF;
}
.modal-background {
    background-color: teal!important;
}

.text-container {
    padding: 0 4rem;
}

</style>
